module.exports = __webpack_public_path__ + "img/Piece-18-Inspect-Medium.5d5a9bdc.png";